export default __webpack_public_path__ + "assets/images/aistudio/views/1ed6936ee06cfeb19d9cad1d29f98bff.png";